import { useEffect } from 'react'

export const TrackOfferzenReferrer = () => {
  useEffect(() => {
    if (process.env.NODE_ENV !== 'development') {
      fetch('/offerzen_referrer')
    }
  })

  return null
}
